import React from "react";

import { EContractType } from "constants/eContract";

import { EContractGenericReviewSection } from "./EContractGenericReviewSection";
import { EContractALPAReviewSection } from "./EContractALPAReviewSection";
import { EContractRMAReviewSection } from "./EContractRMAReviewSection";

interface EContractDataReviewSectionProps {
  agreementId: string;
  eContractType: string | null;
}

export const EContractDataReviewSection = ({
  agreementId,
  eContractType,
}: EContractDataReviewSectionProps): React.JSX.Element => {
  if (eContractType === EContractType.ALPA) {
    return <EContractALPAReviewSection agreementId={agreementId} />;
  }
  if (eContractType === EContractType.RMA) {
    return <EContractRMAReviewSection agreementId={agreementId} />;
  }
  return <EContractGenericReviewSection agreementId={agreementId} />;
};
